import Axios from 'axios'

let store = {
    namespaced: true,
    actions: {
        refreshPaymentPerformance({}, { source, currency }) {
            return Axios.get(`credit-risk/api/v1/payment-performance/${source}/${currency}`)
                .then(res => res.data)
        }
    }
}

export default store;